import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '@store/store';
import ProgramType from 'src/types/programType';
import NavigationHelper from '@components/agile/utils/URLParametersUtils';

export type ProgramState = {
  selectedProgram: ProgramType;
};

const initialProgram: ProgramType =
  NavigationHelper.parseProgramTypeFromPath(window.location.pathname) ?? ProgramType.WholeFoods;

const initialState: ProgramState = {
  selectedProgram: initialProgram,
};

export const programSlice = createSlice({
  name: 'program',
  initialState,
  reducers: {
    updateProgram: (state, action: PayloadAction<ProgramType>) => {
      state.selectedProgram = action.payload;
    },
  },
});

export const { updateProgram } = programSlice.actions;

export const selectProgram = (state: RootState) => state.program.selectedProgram;
export default programSlice.reducer;
